import { renderBrandHeader } from '../branding';
import { esc } from '../helpers';

export type PinGateMode = 'set' | 'enter';

export interface PinGateActions {
  submit(pin: string): void;
  cancel(): void;
}

export function renderPinGate(
  root: HTMLElement,
  mode: PinGateMode,
  error: string | undefined,
  actions: PinGateActions,
): void {
  const isSetting = mode === 'set';

  root.innerHTML = `
    ${renderBrandHeader()}
    <div class="card">
      <h1>${isSetting ? 'Set a Branding PIN' : 'Enter Branding PIN'}</h1>
      <p class="muted">
        ${
          isSetting
            ? 'No PIN is set yet. Choose one now — only share it with whoever should be allowed to change the branding.'
            : 'This screen is protected. Enter the PIN to continue.'
        }
      </p>

      ${error ? `<div class="error-box">${esc(error)}</div>` : ''}

      <label for="pinInput">PIN</label>
      <input type="password" id="pinInput" inputmode="numeric" autocomplete="off" />

      ${
        isSetting
          ? `
        <label for="pinConfirm">Confirm PIN</label>
        <input type="password" id="pinConfirm" inputmode="numeric" autocomplete="off" />
      `
          : ''
      }

      <div class="row" style="margin-top:1rem">
        <button id="cancelBtn" class="secondary" type="button">Cancel</button>
        <button id="submitBtn" type="button">${isSetting ? 'Set PIN' : 'Unlock'}</button>
      </div>
    </div>
  `;

  root.querySelector<HTMLButtonElement>('#cancelBtn')!.addEventListener('click', () => {
    actions.cancel();
  });

  root.querySelector<HTMLButtonElement>('#submitBtn')!.addEventListener('click', () => {
    const pin = root.querySelector<HTMLInputElement>('#pinInput')!.value;

    if (isSetting) {
      const confirmPin = root.querySelector<HTMLInputElement>('#pinConfirm')!.value;
      if (pin.length < 4) {
        renderPinGate(root, mode, 'PIN must be at least 4 characters.', actions);
        return;
      }
      if (pin !== confirmPin) {
        renderPinGate(root, mode, 'PINs do not match.', actions);
        return;
      }
    } else if (!pin) {
      renderPinGate(root, mode, 'Enter the PIN.', actions);
      return;
    }

    actions.submit(pin);
  });
}
